const { decode } = require('he');

const removeHtmlTags = str => str.replace(/(<([^>]+)>)/ig, '');

const stripHtmlOrNull = str => {
  if (!str) {
    return null;
  }
  const stripedStr = removeHtmlTags(decode(str));
  if (stripedStr === str) {
    return null;
  }
  return stripedStr;
};

function formatLastModDate(dateStr, spanish) {
  const date = new Date(dateStr);
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  const locale = spanish ? 'es' : 'en-US';
  return date.toLocaleDateString(locale, options);
}

module.exports = {
  removeHtmlTags,
  stripHtmlOrNull,
  formatLastModDate,
};
